const INITIAL_BASIC_INFO = {
  name: '',
  userCount: '',
  createdBy: '',
  createdDate: '',
  description: '',
  aliceRoleNamePattern: '',
  aliceManaged: null,
  roles: []
};

// eslint-disable-next-line import/prefer-default-export
export { INITIAL_BASIC_INFO };
